import { useGetFieldError } from "app/hooks/useGetFieldError"
import { useEffect } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { getEnvVariable } from "utils"
import { FieldProps } from "app/components/Form/Field"
import { Locales } from "i18n"
import { Control } from "react-hook-form"
import { FormStateValues } from "state/form/types"
import { PreOwnedFormStateValues } from "state/preownedForm/types"
import Turnstile from "react-turnstile"
import FormError from "../../Error"

const TURNSTILE_SITE_KEY = getEnvVariable("REACT_APP_TURNSTILE_SITE_KEY")

type TurnstileFieldProps = Pick<FieldProps, "name" | "rules"> & {
  lang: Locales
  control?: Control<FormStateValues | PreOwnedFormStateValues>
}

const TurnstileField: React.FC<TurnstileFieldProps> = ({ name, lang }) => {
  const { control, setValue } = useFormContext()
  const error = useGetFieldError(name)

  useEffect(() => {
    setValue(name, "")
  }, [])

  return (
    <>
      <Controller
        name="turnstile"
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange } }) => (
          <Turnstile
            sitekey={TURNSTILE_SITE_KEY}
            language={lang}
            onVerify={token => {
              setValue(name, token)
              onChange(token)
            }}
          />
        )}
      />
      {error && <FormError>{error}</FormError>}
    </>
  )
}

export default TurnstileField
